import { useEffect, useState } from 'react';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  FormControl,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
} from '@mui/material';
import { Link, useHistory } from 'react-router-dom';
import { LoadingButton } from '@mui/lab';
import { useForm } from 'react-hook-form';
import { useUser } from './User';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import Container from '@mui/material/Container';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import logo from '../../assets/images/logo-small.png';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import CustomizedSnackbars from '../Common/Notifications/CustomizedSnackbars';

const SignIn = () => {
  const history = useHistory();
  const { user, signIn } = useUser();
  const [response, setResponse] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const {
    register,
    handleSubmit,
    getValues,
    trigger,
    formState: { errors },
  } = useForm({ mode: 'onSubmit' });

  useEffect(() => {
    if (user) {
      // si el usuario esta logueado que lo rediriga a la ultima pagina valida que visito
      history.push(history?.location?.state?.from || '/');
    }
  }, [user, history]);

  const signInHandler = async (data, e) => {
    setLoading(true);
    e.preventDefault();
    setResponse('');
    signInEvent(data.username, data.password);
  };

  const signInEvent = async (username, password) => {
    const res = await signIn(username, password);
    if (res) {
      setResponse('Ingresando a Tableros OSER...');
    } else {
      setResponse('Intente nuevamente');
    }
    setLoading(false);
  };

  const handleOnKeyUp = (e) => {
    let { key, keyCode } = e;
    if (key === 'Enter' && keyCode === 13) {
      trigger();
      getValues('username') !== '' &&
        getValues('password') !== '' &&
        signInEvent(getValues('username'), getValues('password'));
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleBorrarMensaje = () => {
    setResponse('');
  };

  return (
    <>
      {!user && (
        <Container
          maxWidth='xs'
          onKeyUpCapture={handleOnKeyUp}
          disableGutters
          sx={{ mt: { xs: 3, sm: 5 } }}
        >
          <Card>
            <CardContent sx={{ my: { xs: 2, md: 4 }, mx: { xs: 2, md: 5 } }}>
              <Grid
                container
                direction='column'
                justifyContent='center'
                alignItems='center'
                gap={2}
                mb={4}
              >
                <Avatar alt='OSER' src={logo} sx={{ width: 70, height: 70 }} />
                <Typography variant='h4' fontWeight={'bold'}>
                  Iniciar sesión
                </Typography>
              </Grid>

              <form noValidate onSubmit={handleSubmit(signInHandler)}>
                <Box px={1}>
                  <TextField
                    variant='standard'
                    margin='normal'
                    required
                    fullWidth
                    id='username'
                    label='Usuario'
                    name='username'
                    autoComplete='username'
                    autoFocus
                    {...register('username', {
                      required: {
                        value: true,
                        message: 'Debe ingresar CUIL o N° Afiliado',
                      },
                    })}
                  />
                  {errors.username && <p style={{ color: 'red' }}>{errors.username.message}</p>}

                  <FormControl variant='standard' fullWidth required>
                    <InputLabel htmlFor='standard-adornment-password'>Contraseña</InputLabel>
                    <Input
                      id='password'
                      type={showPassword ? 'text' : 'password'}
                      name='password'
                      endAdornment={
                        <InputAdornment position='end'>
                          <IconButton
                            aria-label='toggle password visibility'
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                      {...register('password', {
                        required: {
                          value: true,
                          message: 'Debe ingresar contraseña',
                        },
                      })}
                    />
                    {errors.password && <p style={{ color: 'red' }}>{errors.password.message}</p>}
                  </FormControl>
                </Box>

                <Box sx={{ pt: 4 }}>
                  <LoadingButton
                    fullWidth={true}
                    variant='contained'
                    color='primary'
                    startIcon={<LockOpenIcon />}
                    loading={loading}
                    type='submit'
                  >
                    Ingresar
                  </LoadingButton>
                </Box>

                <LoadingButton component={Link} to={'/olvide-pin'} fullWidth={true} color='primary' sx={{ mt: 2 }}>
                  Olvide mi Contraseña
                </LoadingButton>
              </form>
            </CardContent>
          </Card>

          <CustomizedSnackbars
            open={response}
            severity='success'
            message={response}
            onDeleteMessage={handleBorrarMensaje}
          />
        </Container>
      )}
    </>
  );
};

export default SignIn;
